/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import { createTracker as createTrackerPublic } from 'usage-tracker-public';
import { UsageTracker } from './UsageTracker';
import { waitForGlobal } from './utils.migrated';
import Raven from 'raven-js';
export class UsageTrackerPublic extends UsageTracker {
  constructor() {
    super();
    this.queue = [];
    this.consent = {
      allowed: false,
      categories: {
        necessary: true,
        analytics: false,
        advertisement: false,
        functionality: false
      }
    };
    this.lastScreen = undefined;
    void this.waitForCookieBannerQueue(window);
  }
  get trackerCreator() {
    return createTrackerPublic;
  }
  waitForCookieBannerQueue(win) {
    return waitForGlobal(win, '_hsp').then(_hsp => {
      _hsp.push(['addPrivacyConsentListener', consent => {
        this.consent = consent;
        if (consent.allowed) {
          this.drainQueue();
        }
      }]);
    }).catch(error => {
      Raven.captureException(error);
    });
  }
  queueEvent(event) {
    this.queue.push(event);
  }
  drainQueue() {
    while (this.queue.length > 0) {
      const event = this.queue.shift();
      if (event) {
        if (event.kind === 'standalone') {
          event.tracker.track(event.namespace, event.eventName, event.props);
        } else {
          event.tracker.track(event.eventName, event.props);
        }
      }
    }
  }
  shouldQueue() {
    return !this.consent.allowed;
  }
  _trackWithTracker(tracker, eventName, eventProps) {
    let props = eventProps;
    if (eventProps && eventProps.screen) {
      this.lastScreen = eventProps.screen;
    } else if (this.lastScreen) {
      props = Object.assign({}, eventProps, {
        screen: this.lastScreen
      });
    }
    if (this.shouldQueue()) {
      this.queueEvent({
        kind: 'legacy',
        eventName,
        props,
        tracker
      });
    } else {
      tracker.track(eventName, props);
    }
  }
  _trackWithStandaloneTracker(tracker, eventName, eventProps) {
    let props = eventProps;
    if (eventProps && eventProps.screen) {
      this.lastScreen = eventProps.screen;
    } else if (this.lastScreen) {
      props = Object.assign({}, eventProps, {
        screen: this.lastScreen
      });
    }
    if (this.shouldQueue()) {
      this.queueEvent({
        kind: 'standalone',
        eventName,
        props,
        tracker,
        namespace: 'Learning Center'
      });
    } else {
      tracker.track('Learning Center', eventName, props);
    }
  }
}
export default new UsageTrackerPublic();